export enum CheckOutType {
    TextToPay = 0,
    ScanToPay = 1,
    GrabNGo = 2,
    Demo = 3,
    ScanReceiptToPay  = 4
}